import EditIcon from "@mui/icons-material/Edit";

const Edit = (props: any) => {
  return <EditIcon {...props} />;
};

export default Edit;
